import * as React from 'react'

export const Logo = (props: React.SVGProps<any>) => (
  <svg
    width={78}
    height={78}
    viewBox="0 0 78 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_325_5)">
      <path
        d="M3 28.6C3 19.6392 3 15.1587 4.7439 11.7362C6.27787 8.72556 8.72556 6.27787 11.7362 4.7439C15.1587 3 19.6392 3 28.6 3H49.4C58.3608 3 62.8413 3 66.2638 4.7439C69.2744 6.27787 71.7221 8.72556 73.2561 11.7362C75 15.1587 75 19.6392 75 28.6V49.4C75 58.3608 75 62.8413 73.2561 66.2638C71.7221 69.2744 69.2744 71.7221 66.2638 73.2561C62.8413 75 58.3608 75 49.4 75H28.6C19.6392 75 15.1587 75 11.7362 73.2561C8.72556 71.7221 6.27787 69.2744 4.7439 66.2638C3 62.8413 3 58.3608 3 49.4V28.6Z"
        fill="url(#paint0_linear_325_5)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.4 6H28.6C24.0701 6 20.8531 6.00233 18.3355 6.20802C15.853 6.41085 14.316 6.79637 13.0981 7.41692C10.652 8.66327 8.66327 10.652 7.41692 13.0981C6.79637 14.316 6.41085 15.853 6.20802 18.3355C6.00233 20.8531 6 24.0701 6 28.6V49.4C6 53.9299 6.00233 57.1469 6.20802 59.6645C6.41085 62.147 6.79637 63.684 7.41692 64.9019C8.66327 67.348 10.652 69.3367 13.0981 70.5831C14.316 71.2036 15.853 71.5891 18.3355 71.792C20.8531 71.9977 24.0701 72 28.6 72H49.4C53.9299 72 57.1469 71.9977 59.6645 71.792C62.147 71.5891 63.684 71.2036 64.9019 70.5831C67.348 69.3367 69.3367 67.348 70.5831 64.9019C71.2036 63.684 71.5891 62.147 71.792 59.6645C71.9977 57.1469 72 53.9299 72 49.4V28.6C72 24.0701 71.9977 20.8531 71.792 18.3355C71.5891 15.853 71.2036 14.316 70.5831 13.0981C69.3367 10.652 67.348 8.66327 64.9019 7.41692C63.684 6.79637 62.147 6.41085 59.6645 6.20802C57.1469 6.00233 53.9299 6 49.4 6ZM4.7439 11.7362C3 15.1587 3 19.6392 3 28.6V49.4C3 58.3608 3 62.8413 4.7439 66.2638C6.27787 69.2744 8.72556 71.7221 11.7362 73.2561C15.1587 75 19.6392 75 28.6 75H49.4C58.3608 75 62.8413 75 66.2638 73.2561C69.2744 71.7221 71.7221 69.2744 73.2561 66.2638C75 62.8413 75 58.3608 75 49.4V28.6C75 19.6392 75 15.1587 73.2561 11.7362C71.7221 8.72556 69.2744 6.27787 66.2638 4.7439C62.8413 3 58.3608 3 49.4 3H28.6C19.6392 3 15.1587 3 11.7362 4.7439C8.72556 6.27787 6.27787 8.72556 4.7439 11.7362Z"
        fill="black"
      />
      <path
        d="M3 28.6C3 19.6392 3 15.1587 4.7439 11.7362C6.27787 8.72556 8.72556 6.27787 11.7362 4.7439C15.1587 3 19.6392 3 28.6 3H49.4C58.3608 3 62.8413 3 66.2638 4.7439C69.2744 6.27787 71.7221 8.72556 73.2561 11.7362C75 15.1587 75 19.6392 75 28.6V49.4C75 58.3608 75 62.8413 73.2561 66.2638C71.7221 69.2744 69.2744 71.7221 66.2638 73.2561C62.8413 75 58.3608 75 49.4 75H28.6C19.6392 75 15.1587 75 11.7362 73.2561C8.72556 71.7221 6.27787 69.2744 4.7439 66.2638C3 62.8413 3 58.3608 3 49.4V28.6Z"
        fill="url(#paint1_linear_325_5)"
      />
      <path
        d="M3 28.6C3 19.6392 3 15.1587 4.7439 11.7362C6.27787 8.72556 8.72556 6.27787 11.7362 4.7439C15.1587 3 19.6392 3 28.6 3H49.4C58.3608 3 62.8413 3 66.2638 4.7439C69.2744 6.27787 71.7221 8.72556 73.2561 11.7362C75 15.1587 75 19.6392 75 28.6V49.4C75 58.3608 75 62.8413 73.2561 66.2638C71.7221 69.2744 69.2744 71.7221 66.2638 73.2561C62.8413 75 58.3608 75 49.4 75H28.6C19.6392 75 15.1587 75 11.7362 73.2561C8.72556 71.7221 6.27787 69.2744 4.7439 66.2638C3 62.8413 3 58.3608 3 49.4V28.6Z"
        fill="url(#paint2_linear_325_5)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.532 4.57207e-07C53.9006 -2.24309e-05 57.3626 -4.05461e-05 60.1531 0.227951C63.0066 0.461096 65.4211 0.947528 67.6258 2.07088C71.2009 3.89247 74.1075 6.7991 75.9291 10.3742C77.0525 12.5789 77.5389 14.9934 77.772 17.8469C78 20.6374 78 24.0994 78 28.4679V49.5321C78 53.9006 78 57.3626 77.772 60.1531C77.5389 63.0066 77.0525 65.4211 75.9291 67.6258C74.1075 71.2009 71.2009 74.1075 67.6258 75.9291C65.4211 77.0525 63.0066 77.5389 60.1531 77.772C57.3626 78 53.9006 78 49.5321 78H28.4679C24.0994 78 20.6374 78 17.8469 77.772C14.9934 77.5389 12.5789 77.0525 10.3742 75.9291C6.7991 74.1075 3.89247 71.2009 2.07088 67.6258C0.947527 65.4211 0.461096 63.0066 0.227951 60.1531C-4.05461e-05 57.3626 -2.2431e-05 53.9006 4.57209e-07 49.532V28.468C-2.2431e-05 24.0994 -4.05461e-05 20.6374 0.227951 17.8469C0.461096 14.9934 0.947528 12.5789 2.07088 10.3742C3.89247 6.7991 6.7991 3.89247 10.3742 2.07088C12.5789 0.947527 14.9934 0.461096 17.8469 0.227951C20.6374 -4.05461e-05 24.0994 -2.24309e-05 28.468 4.57207e-07H49.532ZM4.7439 11.7362C3 15.1587 3 19.6392 3 28.6V49.4C3 58.3608 3 62.8413 4.7439 66.2638C6.27787 69.2744 8.72556 71.7221 11.7362 73.2561C15.1587 75 19.6392 75 28.6 75H49.4C58.3608 75 62.8413 75 66.2638 73.2561C69.2744 71.7221 71.7221 69.2744 73.2561 66.2638C75 62.8413 75 58.3608 75 49.4V28.6C75 19.6392 75 15.1587 73.2561 11.7362C71.7221 8.72556 69.2744 6.27787 66.2638 4.7439C62.8413 3 58.3608 3 49.4 3H28.6C19.6392 3 15.1587 3 11.7362 4.7439C8.72556 6.27787 6.27787 8.72556 4.7439 11.7362Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.532 4.57207e-07C53.9006 -2.24309e-05 57.3626 -4.05461e-05 60.1531 0.227951C63.0066 0.461096 65.4211 0.947528 67.6258 2.07088C71.2009 3.89247 74.1075 6.7991 75.9291 10.3742C77.0525 12.5789 77.5389 14.9934 77.772 17.8469C78 20.6374 78 24.0994 78 28.4679V49.5321C78 53.9006 78 57.3626 77.772 60.1531C77.5389 63.0066 77.0525 65.4211 75.9291 67.6258C74.1075 71.2009 71.2009 74.1075 67.6258 75.9291C65.4211 77.0525 63.0066 77.5389 60.1531 77.772C57.3626 78 53.9006 78 49.5321 78H28.4679C24.0994 78 20.6374 78 17.8469 77.772C14.9934 77.5389 12.5789 77.0525 10.3742 75.9291C6.7991 74.1075 3.89247 71.2009 2.07088 67.6258C0.947527 65.4211 0.461096 63.0066 0.227951 60.1531C-4.05461e-05 57.3626 -2.2431e-05 53.9006 4.57209e-07 49.532V28.468C-2.2431e-05 24.0994 -4.05461e-05 20.6374 0.227951 17.8469C0.461096 14.9934 0.947528 12.5789 2.07088 10.3742C3.89247 6.7991 6.7991 3.89247 10.3742 2.07088C12.5789 0.947527 14.9934 0.461096 17.8469 0.227951C20.6374 -4.05461e-05 24.0994 -2.24309e-05 28.468 4.57207e-07H49.532ZM4.7439 11.7362C3 15.1587 3 19.6392 3 28.6V49.4C3 58.3608 3 62.8413 4.7439 66.2638C6.27787 69.2744 8.72556 71.7221 11.7362 73.2561C15.1587 75 19.6392 75 28.6 75H49.4C58.3608 75 62.8413 75 66.2638 73.2561C69.2744 71.7221 71.7221 69.2744 73.2561 66.2638C75 62.8413 75 58.3608 75 49.4V28.6C75 19.6392 75 15.1587 73.2561 11.7362C71.7221 8.72556 69.2744 6.27787 66.2638 4.7439C62.8413 3 58.3608 3 49.4 3H28.6C19.6392 3 15.1587 3 11.7362 4.7439C8.72556 6.27787 6.27787 8.72556 4.7439 11.7362Z"
        fill="url(#paint3_linear_325_5)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.8812 59.9413L34.1723 60L23 52.1978L26.8198 46.9181L35.3499 53.2831L44.5835 53.1658L49.5235 50.5112L48.8773 44.6889L27.6384 35.8602L26.705 25.5208L33.8851 17.1173L48.0587 17L56 25.5208L50.5288 29.3779L44.6984 22.6463L37.8773 22.529L33.7559 26.4887L34.0575 31.8271L54.2911 39.9372L55.6985 53.7524L46.8812 59.9413Z"
        fill="url(#paint4_linear_325_5)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_325_5"
        x1={39}
        y1={-20}
        x2={39}
        y2={75}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C4C57" />
        <stop offset={0.444444} stopColor="#05050A" />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="paint1_linear_325_5"
        x1={39}
        y1={-20}
        x2={39}
        y2={75}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C4C57" />
        <stop offset={0.444444} stopColor="#05050A" />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="paint2_linear_325_5"
        x1={39}
        y1={-20}
        x2={39}
        y2={75}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C4C57" />
        <stop offset={0.444444} stopColor="#05050A" />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="paint3_linear_325_5"
        x1={39}
        y1={3}
        x2={39}
        y2={75}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity={0.6} />
        <stop offset={1} stopColor="white" stopOpacity={0.2} />
      </linearGradient>
      <linearGradient
        id="paint4_linear_325_5"
        x1={39.5}
        y1={17}
        x2={39.5}
        y2={60}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <clipPath id="clip0_325_5">
        <rect width={78} height={78} fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const LogoText = (props: React.SVGProps<any>) => (
  <svg
    width={176.036072}
    height={52.628906}
    viewBox="0 0 176.036 52.6289"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <desc>{'\n\t\t\tCreated with Pixso.\n\t'}</desc>
    <defs />
    <path
      id="Suite"
      d="M29.2324 51.4688L13.6758 51.5391L0 42.1875L4.67578 35.8594L15.1172 43.4883L26.4199 43.3477L32.4668 40.166L31.6758 33.1875L5.67773 22.6055L4.53516 10.2129L13.3242 0.140625L30.6738 0L40.3945 10.2129L33.6973 14.8359L26.5605 6.76758L18.2109 6.62695L13.166 11.373L13.5352 17.7715L38.3027 27.4922L40.0254 44.0508L29.2324 51.4688ZM79.7086 52.418L75.3141 47.0918L62.1305 52.6289L44.7106 45.2109L45.1325 13.8867L52.4801 12.9551L52.5504 40.2363L61.9899 43.9102L73.8727 39.0234L74.0133 13.6758L82.0114 12.8848L82.0817 43.6289L85.8258 47.584L79.7086 52.418ZM90.144 4.60547L97.6323 1.79297L101.165 12.0234L93.8178 13.0957L90.144 4.60547ZM92.5874 15.9082L100.445 16.2598L100.216 51.4688L92.5874 52.3477L92.5874 15.9082ZM121.598 20.373L120.807 39.2344L131.389 44.4199L128.524 52.0488L113.828 44.4902L113.758 20.3027L106.27 20.2324L105.479 13.3066L113.758 13.0254L113.758 3.60352L122.318 3.88477L121.967 12.8145L132.549 12.4453L131.758 20.4434L121.598 20.373ZM176.036 41.2559L165.964 51.7676L145.731 51.627L135.431 39.1641L136.151 24.0469L148.104 12.8848L163.661 12.8848L174.893 24.0469L173.874 32.3262L152.059 36.6504L150.477 29.6543L166.597 26.5605L160.708 20.0918L151.708 19.9336L143.429 28.5117L143.341 36.4922L150.038 44.3496L162.22 43.7695L169.339 36.2109L176.036 41.2559Z"
      fillRule="evenodd"
      fill="#000000"
    />
  </svg>
)

interface LogoProps {
  className: string
}

export function ShanMuShanLogo(props: LogoProps) {
  return (
    <svg
      viewBox="0 0 180 56"
      fill="none"
      className={`p-2 h-10 w-auto ${props.className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M124.4 0.199997H180V55.8L124.4 0.199997Z" fill="#FFCC66" />
      <path
        d="M0 50.8V10.55H7.95V45.85H21V5.2H29V45.85H42.05V10.55H50V47C50 48.0667 49.6333 48.9667 48.9 49.7C48.1667 50.4333 47.2667 50.8 46.2 50.8H0ZM102.95 50.8L92.9 20.6H101.4L111.5 50.8H102.95ZM57.55 17.5V12.55H81.1V5.2H88.9V12.55H112.8L111 17.5H88.9V50.8H81.1V17.5H57.55ZM58.5 50.8L68.6 20.6H77.1L67.05 50.8H58.5ZM120 50.8V10.55H127.95V45.85H141V5.2H149V45.85H162.05V10.55H170V47C170 48.0667 169.633 48.9667 168.9 49.7C168.167 50.4333 167.267 50.8 166.2 50.8H120Z"
        fill="#4834D5"
      />
    </svg>
  )
}

export default Logo
